/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockReportSupplierCtrl
 */
angular.module('mercury.modules.stock.report')
.controller('StockReportSupplierCtrl', ["dialog", "$q", "reporttime", "$scope", "$stateParams", "StockPurchaseOrders", "StockSupplierStatements", "title", function(dialog, $q, reporttime, $scope, $stateParams, StockPurchaseOrders, StockSupplierStatements, title) {
  title.set('Orders By Suppliers');

  reporttime.defaultType = 'week';

  //Passed to new statements
  $scope.report = $stateParams.report;

  $scope.suppliers = [];
  $scope.allOrders = StockPurchaseOrders.getArchive(reporttime.start(), reporttime.end());
  $scope.allStatements = StockSupplierStatements.getAll(reporttime.start(), reporttime.end());

  $q.all([$scope.allOrders.$promise, $scope.allStatements.$promise])
  .then(function() {
    var supplierGroups = {};

    angular.forEach($scope.allOrders, function(order) {
      if (!supplierGroups[order.supplierId]) {
        supplierGroups[order.supplierId] = {name: order.supplierName, orders: [], statements: []};
      }

      supplierGroups[order.supplierId].orders.push(order);
    });

    angular.forEach($scope.allStatements, function(statement) {
      if (!supplierGroups[statement.supplierId]) {
        supplierGroups[statement.supplierId] = {name: statement.supplierName, orders: [], statements: []};
      }

      supplierGroups[statement.supplierId].statements.push(statement);
    });

    angular.forEach(supplierGroups, function(supplierGroup) {
      $scope.suppliers.push(supplierGroup);
    });
  });

  /**
  * Returns the sum of a specified field for an array of orders
  *
  * @param {Object} orders - The array of orders to sum
  * @param {String} field - The field to sum with.
  */
  $scope.totals = function(orders, field) {
    var totals = 0;
    angular.forEach(orders, function(order) {
      totals += parseFloat(order[field]);
    });
    return totals;
  };

  /**
  * Returns the count of unreconciled orders
  *
  * @param {Object} orders - The array of orders to count
  */
  $scope.countUnreconciled = function(orders) {
    var count = 0;
    angular.forEach(orders, function(order) {
      if (!order.reconciled) {
        count++;
      }
    });
    return count;
  };

  $scope.print = function() {
    window.print();
  };

}]);
